"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Auth-service API
 * API for Auth Service
 *
 * The version of the OpenAPI document: 2.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginStateTokenDTOLoginStateEnum = void 0;
exports.LoginStateTokenDTOLoginStateEnum = {
    Unknown: 'UNKNOWN',
    LoggedIn: 'LOGGED_IN',
    MfaRegister: 'MFA_REGISTER',
    MfaValidate: 'MFA_VALIDATE'
};
